import { string } from 'yup'

export default string()
  .required()
  .min(20, 'Biography need to be at least 20 characters')
  .max(500, 'Biography can be more than 500 characters')
